/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsDto } from '../../models/news-dto';

export interface NewsControllerFindAllV1$Params {
}

export function newsControllerFindAllV1(http: HttpClient, rootUrl: string, params?: NewsControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NewsDto>>> {
  const rb = new RequestBuilder(rootUrl, newsControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NewsDto>>;
    })
  );
}

newsControllerFindAllV1.PATH = '/api/v1/news';
